import React, { useEffect, useState } from "react";
import Select from "react-select";
import { teams } from "../../utils/constants";
import API from "../../services/api";

function TeamwiseReports(props) {
  const {year, month, newReports} = props
  const [team, SetTeam] = useState();
  const [teamData, setTeamData] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month-1))
  function getStartAndEndOfMonthTimestamps(year, month) {
    // Months are zero-indexed in JavaScript (0 for January, 11 for December)
    const startDate = new Date(year, month - 1, 1); // Start of the month
    const endDate = new Date(year, month, 0); // End of the month (0th day of the next month)
  
    // Convert to timestamps (in seconds)
    const startTimestamp = Math.floor(startDate.getTime() / 1000);
    const endTimestamp = Math.floor(endDate.getTime() / 1000);
  
    return { startTimestamp, endTimestamp };
  }
  function getDaysInMonth(year, month) {
    // Months are zero-indexed in JavaScript (0 for January, 11 for December)
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();
    return lastDayOfMonth;
  }
  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(year, month);
  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1); 
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + (times * 86400)
  }
  function calculateSpent( salesId, targetBusiness, index) {
    let targetDate = getTimestamp(index)
    const result = teamData.find((entry) => 
      entry.sales_id === salesId &&
      entry.date === targetDate &&
      entry.business === targetBusiness
    );
    return result ? result.spent : 0;
  }
  const FetchData = async () => {
    try {
      let res = await API({
        url: "/reports/teamwisereports",
        method: "POST",
        responseType: "json",
        data: {
          team,
          startTimestamp,
           endTimestamp,
           newReport:newReports
        },
      });
      if (res.code === 200) {
        setTeamData(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const FetchSalesPersons = async () => {
    try {
      let res = await API({
        url: "/reports/teamwisesales",
        method: "POST",
        responseType: "json",
        data: {
          team,
        },
      });
      if (res.code === 200) {
        setTeamMembers(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const CalculateTotal = (index)=>{
    let targetDate = getTimestamp(index)
    const totalSpent = teamData.reduce((sum, entry) => {
      if (entry.date === targetDate && entry.spent) {
        return sum + entry.spent;
      }
      return sum;
    }, 0);
  
    return parseFloat(totalSpent).toFixed(2);
  }

  const CalculateOldBusiness = (index)=>{
    let targetDate = getTimestamp(index)
    const totalSpent = teamData.reduce((sum, entry) => {
      if (entry.business === 0 && entry.date === targetDate && entry.spent) {
        return sum + entry.spent;
      }
      return sum;
    }, 0);
  
    return parseFloat(totalSpent).toFixed(2);
  }

  const CalculateNewBusiness = (index)=>{
    let targetDate = getTimestamp(index)
    const totalSpent = teamData.reduce((sum, entry) => {
      if (entry.business === 1 && entry.date === targetDate && entry.spent) {
        return sum + entry.spent;
      }
      return sum;
    }, 0);
  
    return parseFloat(totalSpent).toFixed(2);
  }

  const calculateEcpm = (index) =>{
    let targetDate = getTimestamp(index)
    const totalImpressions = teamData.reduce((sum, entry) => {
      if (entry.date === targetDate && entry.impressions) {
        return sum + entry.impressions;
      }
      return sum;
    }, 0);
    console.log(totalImpressions)
    let impresssions = totalImpressions;
    let total = CalculateTotal(index)
    let ecpm = (total/impresssions) * 1000
    return ((!isNaN(ecpm)&& ecpm !== Infinity) ? parseFloat(ecpm).toFixed(2) : "-")
  }
  const handleCurrentDay = ()=>{
    setCurrentDay(getDaysInMonth(year, month -1))
  }

  function getMonthName(monthNumber) {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  
    // Check if the input is a valid month number
    if (monthNumber >= 1 && monthNumber <= 12) {
      return months[monthNumber - 1];
    }
  }
  function capitalizeFirstLetter(string) {
    return string?.charAt(0).toUpperCase() + string?.slice(1);
}

  function calculateSpentColumnTotal(salesId, targetBusiness) {
    let total = 0;
    if (teamData.length) {
      teamData.map((item) => {
        if (item.sales_id === salesId && item.business === targetBusiness) {
          total += parseFloat(item.spent);
        } else {
          total += 0;
        }
      });
      return total;
    } else {
      return 0;
    }
  }
  const CalculateSalesTeamTotal = () => {
    let sum = 0;
    if (teamData.length) {
      teamData.map((item) => {
        item.spent ? sum += parseFloat(item.spent) : sum += 0
      })
      return parseFloat(sum).toFixed(2);
    }
    else {
      return 0;
    }
  }
  const CalculateBusinessTotal = (type) => {
    if (teamData.length) {
      if (type === "new_business") {
        let sum = 0;
        teamData.map((item) => {
          if (item.business === 1 && item.spent) {
            sum += parseFloat(item.spent);
          }
        })
        return parseFloat(sum).toFixed(2);
      } else if (type === "old_business") {
        let sum = 0;
        teamData.map((item) => {
          if (item.business === 0 && item.spent) {
            sum += parseFloat(item.spent);
          }
        })
        return parseFloat(sum).toFixed(2);
      } else if (type === "ecpm_total") {
        let ecpms = [];
        let ecpmsSum = 0;
        for (let rowIndex = 0; rowIndex < currentDay; rowIndex++) {
          if (teamData.length) {
            let targetDate = getTimestamp(rowIndex)
            const totalImpressions = teamData.reduce((sum, entry) => {
              if (entry.date === targetDate && entry.impressions) {
                return sum + entry.impressions;
              }
              return sum;
            }, 0);
            let impresssions = totalImpressions;
            let total = CalculateTotal(rowIndex)
            let ecpm = (total / impresssions) * 1000;
            if ((!isNaN(ecpm) && ecpm !== Infinity)) {
              ecpms.push(ecpm);
            }
          }
        }
        if (ecpms.length > 0) {
          ecpms?.map((item) => {
            ecpmsSum += item;
          })
          return (parseFloat(ecpmsSum) / (ecpms.length)).toFixed(2)
        } else {
          return 0;
        }
      }
    }
  }

  useEffect(() => {
    if (team) {
      FetchData();
      handleCurrentDay()
    }
  }, [team, month, year, newReports]);

  useEffect(()=>{
    if(team)
    FetchSalesPersons()
  },[team])

  return (
    <>
    <h5>Select Team</h5>
      <div className="d-flex gap-3">
        <Select
          className="mb-3 w-44"
          options={teams}
          onChange={(e) => SetTeam(e.value)}
        />
        <h6>Slected Team: {capitalizeFirstLetter(team)}</h6>
      </div>
    <div className="report-image">
     {team ?  <div className="overflow-x-auto responsive-table">
        <table className="table table-bordered report-table" id="teamwise-report">
          <thead>
            <tr>
              <td colSpan={teamMembers.length + 5}>
              <h4>{`${capitalizeFirstLetter(team)} - ${getMonthName(month)}` }</h4>
              </td>
            </tr>
            <tr>
              <th>Date</th>
              {teamMembers?.map((item, index) => {
                return <th>{item?.name}</th>;
              })}
              <th>Total</th>
              <th>New Business</th>
              <th>Old Business</th>
              <th>ECPM</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: currentDay }, (_, index) => (
              <tr key={index}>
                <td>{`${index + 1}-${month}-${year}`}</td>
                {teamMembers?.map((item, index1) => {
                return <td>{calculateSpent(item.sales_person_id, 1, index) + calculateSpent(item.sales_person_id, 0, index)}</td>;
              })}
                <td>{CalculateTotal(index)}</td>
                <td>{CalculateNewBusiness(index)}</td>
                <td>{CalculateOldBusiness(index)}</td>
                <td>{calculateEcpm(index)}</td>
              </tr>
            ))}
              <tr>
                <td>Total</td>
                {teamMembers?.map((item, index) => {
                  return <td>{parseFloat(calculateSpentColumnTotal(item.sales_person_id, 1) + calculateSpentColumnTotal(item.sales_person_id, 0)).toFixed(2)}</td>;
                })}
                <td>{CalculateSalesTeamTotal()}</td>
                <td>{CalculateBusinessTotal("new_business")}</td>
                <td>{CalculateBusinessTotal("old_business")}</td>
                <td>{CalculateBusinessTotal("ecpm_total")}</td>
              </tr>
          </tbody>
        </table>
      </div> : null}
    </div>
    </>
  );
}

export default TeamwiseReports;
